import {language} from "./text/text";
import {Ilanguage} from "../../interface/Icommon";


export const alllanguage: Ilanguage = language

export enum lanAssetConfig {
    continue_btn = "assets/lang/langCode/continue_btn.png"
}